import { defineMessages } from 'react-intl'

const messages = defineMessages({
  placeholder: {
    id: 'TypeAheadFilter.placeholder',
    description: 'Texto para el placeholder del filtro TypeAhead',
    defaultMessage: 'Región o país'
  },
  placeholder2: {
    id: 'TypeAheadFilter.placeholder2',
    description: 'Texto para el placeholder del filtro TypeAhead',
    defaultMessage: 'Añadir regiones y/o países'
  }
})

export default messages



// WEBPACK FOOTER //
// ./src/modules/Filters/TypeAheadFilter/messages.js